import { formatToUserCurrency } from './formatToUserCurrency';

export const formatAmountToKilo = (amount: number, { formatToCurrency = false } = {}): string => {
    let value = amount;
    let symbol = '';

    if (amount >= 100 && amount < 1000 && !Number.isInteger(amount)) {
        symbol = '+';
        value = Math.trunc(amount);
    } else if (amount >= 1000) {
        if (Number.isInteger(amount / 100)) {
            value = amount / 1000;
            symbol = 'K';
        } else {
            value = Math.trunc(amount / 100) / 10;
            symbol = 'K+';
        }
    }

    return `${
        formatToCurrency
            ? formatToUserCurrency(value, { reverseTemplate: true, removeTrailingZeroes: true })
            : value
    }${symbol}`;
};
